import { isEmpty, isNil } from 'lodash';
import { applyForWaitlist as applyForWaitlistAPI } from '../APIClient/users';

export const UPDATE_CREATOR_APPLICATION = 'UPDATE_CREATOR_APPLICATION';
export const CREATOR_APPLICATION_SUCCESS = 'CREATOR_APPLICATION_SUCCESS';
export const CREATOR_APPLICATION_FAILURE = 'CREATOR_APPLICATION_FAILURE';
export const CLEAR_CREATOR_APPLICATION = 'CLEAR_CREATOR_APPLICATION';

export const updateCreatorApplication = updates => async dispatch => {
  return dispatch({ type: UPDATE_CREATOR_APPLICATION, updates });
};

export const applyToCreatorWaitlist = () => async (dispatch, getState) => {
  const application = getState().application.creatorApplication;
  const attribution = getState().attribution;

  // remove empty fields / string values from application
  for (const key in application) if (application[key] === '' || isNil(application[key])) delete application[key];

  const source_fields = attribution.params || {};
  try {
    const applicationData = { ...application };
    if (!isEmpty(source_fields)) applicationData.source_fields = source_fields;
    applicationData.phone = `+${applicationData.phoneExtension}${applicationData.phone}`;
    delete applicationData.phoneExtension;
    delete applicationData.referringUser;
    delete applicationData.referringBrand;

    const resp = await applyForWaitlistAPI(applicationData);
    return dispatch({
      success: true,
      type: CREATOR_APPLICATION_SUCCESS,
      data: resp
    });
  } catch (error) {
    return dispatch({
      type: CREATOR_APPLICATION_FAILURE,
      error: error
    });
  }
};

export const clearCreatorApplication = () => async dispatch => {
  return dispatch({ type: CLEAR_CREATOR_APPLICATION, success: true });
};
